import React from "react";
import { Button, TableRow, TableCell } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { API_URL } from "../../api/axios";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";

const ManagePagesTableCollapse = ({
  item,
  detailViewHandler,
  updatePageHandler,
  deletePageHandler,
}) => {
  return (
    <TableRow>
      {item.page_image ? (
        <TableCell align="left">
          <img
            alt=""
            height="40px"
            width="40px"
            style={{ cursor: "pointer", borderRadius: "3%" }}
            src={`${API_URL}/uploads/pages/${item.page_image}`}
          />
        </TableCell>
      ) : (
        <TableCell>
          <img
            alt=""
            height="40px"
            width="40px"
            style={{ cursor: "pointer", borderRadius: "3%" }}
            src="https://i.postimg.cc/vZvJdnRS/blank-head-profile-pic-for-a-man.jpg"
          />
        </TableCell>
      )}

      <TableCell sx={{ fontSize: "13px" }}>{item.page_title}</TableCell>
      <TableCell sx={{ fontSize: "13px" }}>
        {item.status ? (
          <CheckIcon style={{ color: " #69CCA4" }} />
        ) : (
          <ClearIcon style={{ color: "red" }} />
        )}
      </TableCell>
      <TableCell>
        <Button
          style={{
            marginRight: "3px",
            padding: "5px",
            minWidth: "10px",
            fontSize: "13px",
            backgroundColor: "#0b6885",
          }}
          variant="contained"
          onClick={() => detailViewHandler(item.unique_id)}
        >
          <VisibilityIcon style={{ fontSize: 13 }} />
        </Button>
        <Button
          style={{
            marginRight: "3px",
            padding: "5px",
            minWidth: "10px",
            fontSize: "13px",
            backgroundColor: "#2a80f9",
          }}
          variant="contained"
          onClick={() => updatePageHandler(item.unique_id)}
        >
          <Edit style={{ fontSize: 13 }} />
        </Button>
        <Button
          style={{
            marginRight: "1px",
            padding: "5px",
            minWidth: "10px",
            fontSize: "13px",
            backgroundColor: "#ea3f4d",
          }}
          variant="contained"
          onClick={() => deletePageHandler(item.unique_id)}
        >
          <Delete style={{ fontSize: 13 }} />
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default ManagePagesTableCollapse;
